import { omit } from '@antv/util';
import { createPluginContainer } from '../../utils/dom';
import { BasePlugin } from '../base-plugin';
/**
 * <zh/> 背景图
 *
 * <en/> Background image
 * @remarks
 * <zh/> 支持为图画布设置一个背景图片，让画布更有层次感、叙事性。
 *
 * <en/> Support setting a background image for the canvas to make the canvas more hierarchical and narrative.
 */
export class Background extends BasePlugin {
    static defaultOptions = {
        transition: 'background 0.5s',
        backgroundSize: 'cover',
    };
    $element = createPluginContainer('background');
    constructor(context, options) {
        super(context, Object.assign({}, Background.defaultOptions, options));
        const $container = this.context.canvas.getContainer();
        $container.prepend(this.$element);
        this.update(options);
    }
    /**
     * <zh/> 更新背景图配置
     *
     * <en/> Update the background image configuration
     * @param options - <zh/> 配置项 | <en/> Options
     * @internal
     */
    async update(options) {
        super.update(options);
        // Set the background style.
        Object.assign(this.$element.style, omit(this.options, ['key', 'type']));
    }
    /**
     * <zh/> 销毁背景图
     *
     * <en/> Destroy the background image
     */
    destroy() {
        super.destroy();
        // Remove the background dom.
        this.$element.remove();
    }
}
//# sourceMappingURL=index.js.map